module.exports = __webpack_public_path__ + "static/media/dn.6230a336.mp3";